export default [
    {
        "userId": "",
        "userName": "",
        "password": "",
        "roleMastId": "",
        "roleMastJson": "",
    }
]